// Curated stock imagery used as tasteful fallbacks when a project/room/product
// has no real uploaded photograph yet.

export const ROOM_STOCK_IMAGES = {
  living: "https://images.unsplash.com/photo-1641232458416-feace752b346?crop=entropy&cs=srgb&fm=jpg&q=80&w=640",
  bedroom: "https://images.unsplash.com/photo-1586205009278-cf9854b97d0c?crop=entropy&cs=srgb&fm=jpg&q=80&w=640",
  dining: "https://images.unsplash.com/photo-1560185007-cde436f6a4d0?crop=entropy&cs=srgb&fm=jpg&q=80&w=640",
  default: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&q=80&w=640",
};

export function roomImageFor(roomName = "") {
  const n = roomName.toLowerCase();
  if (n.includes("bed")) return ROOM_STOCK_IMAGES.bedroom;
  if (n.includes("din") || n.includes("kitchen")) return ROOM_STOCK_IMAGES.dining;
  if (n.includes("living") || n.includes("hall")) return ROOM_STOCK_IMAGES.living;
  return ROOM_STOCK_IMAGES.default;
}

export const PRODUCT_FALLBACK_IMAGES = [
  "https://images.unsplash.com/photo-1599280611965-bef72efc48fb?crop=entropy&cs=srgb&fm=jpg&q=80&w=640",
  "https://images.unsplash.com/photo-1601056639638-c53c50e13ead?crop=entropy&cs=srgb&fm=jpg&q=80&w=640",
  "https://images.unsplash.com/photo-1686806374120-e7ae3f19801d?crop=entropy&cs=srgb&fm=jpg&q=80&w=640",
  "https://images.unsplash.com/photo-1643313262988-cdc5f50c6019?crop=entropy&cs=srgb&fm=jpg&q=80&w=640",
];

export function productImageFor(seed = "") {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  return PRODUCT_FALLBACK_IMAGES[hash % PRODUCT_FALLBACK_IMAGES.length];
}

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

const ROOM_IMAGE_LIST = Object.values(ROOM_STOCK_IMAGES);

// Stable pick so the same project/enquiry always shows the same stock room.
export function roomImageForSeed(seed = "") {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  return ROOM_IMAGE_LIST[hash % ROOM_IMAGE_LIST.length];
}

export const CUSTOMERS_HERO_IMAGE =
  "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

export const PROJECTS_HERO_IMAGE =
  "https://images.unsplash.com/photo-1618220179428-22790b461013?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

export const QUOTATIONS_HERO_IMAGE =
  "https://images.unsplash.com/photo-1615874959474-d609969a20ed?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

export const CATALOGUES_HERO_IMAGE =
  "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

export const PDF_IMPORT_IMAGE =
  "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?crop=entropy&cs=srgb&fm=jpg&q=80&w=900";

const SHOWROOM_IMAGES = [
  HERO_IMAGE,
  CUSTOMERS_HERO_IMAGE,
  PROJECTS_HERO_IMAGE,
  QUOTATIONS_HERO_IMAGE,
  ROOM_STOCK_IMAGES.living,
  ROOM_STOCK_IMAGES.dining,
];

// Showrooms have no photo field yet, so each gets a stable stock interior.
export function showroomImageFor(seed = "") {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  return SHOWROOM_IMAGES[hash % SHOWROOM_IMAGES.length];
}

export const SHOWROOM_DIALOG_IMAGE = CUSTOMERS_HERO_IMAGE;
